<template>
  <div class="v-application">
    

    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

    <!-- begin::Body -->
     <div class="portal-content d-flex content d-flex flex-column flex-column-fluid container-fluid" v-bind:id="cssId">
        <!-- begin:: Header -->
        <!-- begin:: Header Mobile -->
        <KTHeaderMobile></KTHeaderMobile>
        <!-- end:: Header Mobile -->
        <KTHeader></KTHeader>
        
        <!-- end:: Header -->

        <!-- begin:: Content -->
           <!-- begin:: Content Head -->
           <div style="display:none">
          <KTSubheader
            v-if="subheaderDisplay"
            v-bind:breadcrumbs="breadcrumbs"
            v-bind:title="pageTitle"
          />
          </div>
          <!-- end:: Content Head -->

          <!-- begin:: Content Body -->
                  <transition name="fade-in-up">
                    <router-view />
                  </transition>
                   <!-- end:: Content Body -->
    </div>
    <KTFooter v-if="footerLayout('compact')"></KTFooter>
    <FooterExtended v-if="footerLayout('extended')"></FooterExtended>
    <KTScrollTop></KTScrollTop>
   
              
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapState } from "vuex";
//import KTAside from "@/view/layout/aside/Aside.vue";
import StyleService from "@/core/services/style.service";
import KTHeader from "@/view/layout/header/Header.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import FooterExtended from "@/view/layout/footer/FooterExtended.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import Loader from "@/view/content/Loader.vue";
import { CREATE_TASK_JIRA } from "@/core/services/store/jira.module";
//import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/core/services/store/htmlclass.module.js";

export default {
  name: "Layout",
  components: {
    KTHeader,
    KTHeaderMobile,
    KTFooter,
    FooterExtended,
    KTSubheader,
    KTScrollTop,
    Loader
  },
  data() {
    return {
      tituloError:null,
      descripcionError:null,
      modalError:false,
      cssId:''
    }

  },
 created() {
    this.cssId = StyleService.getCss();
  },
  beforeMount() {
    // show page loading
    //window.localStorage.setItem("config", {"self.logo.default":"munich.svg"});
    //this.layoutConfig("self.logo.default", "munich.svg");
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
    
  },
  mounted() {
    // check if current user is authenticated
    // Simulate the delay page loading
    setTimeout(() => {
      // Remove page loader after some time
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }, 100);
  },
  methods: {
    sendTask() {
      if (this.tituloError==null || this.tituloError=='') {
        return;
      }
      const descripcionError = `Declara Error: \n\t ${this.descripcionError}`;
      this.$store
        .dispatch(CREATE_TASK_JIRA, { project:'', module:'', title:this.tituloError, description:descripcionError })
        .then(() => {
          this.modalError = false;
          this.tituloError=null;
          this.descripcionError=null;
        });
    },
    footerLayout(type) {
      return this.layoutConfig("footer.layout") === type;
    }
  },
  ...mapState({
      client: state => state.auth.user
      }
  ),
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    }
  }
};
</script>
<style>
.v-btn--fab.v-size--large.v-btn--absolute.v-btn--top {
    top: 70px!important;
}
</style>